import { render, staticRenderFns } from "./TextEditor.vue?vue&type=template&id=43a8f3d5&scoped=true&"
import script from "./TextEditor.vue?vue&type=script&lang=js&"
export * from "./TextEditor.vue?vue&type=script&lang=js&"
import style0 from "./TextEditor.vue?vue&type=style&index=0&id=43a8f3d5&lang=scss&scoped=true&"
import style1 from "./TextEditor.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43a8f3d5",
  null
  
)

export default component.exports